import { useRef } from "react";

import { twMerge } from "@/utils/twMerge";

import { CORNERS, LEFT_EYE, MOUTH_SMILE, MOUTH_TYPING } from "./paths";
import { useIdleBlink } from "./useIdleBlink";

const CORNER_STROKE = "var(--color-icon-secondary)";
const FACE_STROKE = "var(--color-icon-main)";

export type AiLogoState = "idle" | "focus" | "typing";

function getMouthPath(state: AiLogoState): string {
  return state === "typing" ? MOUTH_TYPING : MOUTH_SMILE;
}

export function AiLogo({
  state,
  size = 32,
  className,
}: {
  state: AiLogoState;
  size?: number;
  className?: string;
}) {
  const eyesRef = useRef<SVGGElement>(null);

  useIdleBlink({ enabled: state === "idle", eyesRef });

  return (
    <svg
      className={twMerge("block overflow-visible motion-reduce:**:animate-none!", className)}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <g
        className={twMerge(
          "origin-[16px_16px]",
          state === "focus" && "origin-[16px_20px] animate-ai-logo-focus-bounce",
        )}
      >
        <path d={CORNERS} stroke={CORNER_STROKE} strokeLinecap="round" />
        <g className="origin-[16px_16px]">
          <g
            ref={eyesRef}
            className={twMerge(
              "origin-[16px_16px]",
              state === "focus" && "animate-ai-logo-focus-squint",
              state === "typing" && "animate-ai-logo-typing-scan",
            )}
          >
            <path d={LEFT_EYE} stroke={FACE_STROKE} />
            <rect
              x="22.1667"
              y="14.1667"
              width="3.66667"
              height="3.66666"
              rx="1.83333"
              stroke={FACE_STROKE}
            />
          </g>
          <path
            className="origin-[16px_16px]"
            d={getMouthPath(state)}
            stroke={FACE_STROKE}
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  );
}
